import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from "react";
import isAllowedReactElement from "./allowed-reactEls";
import reactElementToCodeItem from "./reactEl-to-codeItem";
import codeItemToDomElement from "./codeItem-to-dom";
import codeItemToReactElement from "./codeItem-to-reactEl";
import codeItemsToRawHtmlBody from "./codeItems-to-rawHtmlBody";
var selectorPosition = {
  'beginOfHead': ['head', 'afterbegin'],
  'endOfHead': ['head', 'beforeend'],
  'beginOfBody': ['body', 'afterbegin'],
  'endOfBody': ['body', 'beforeend']
};
var CODE_ITEMS = [];

function getComponents() {
  var exported = _toConsumableArray(CODE_ITEMS);

  CODE_ITEMS = [];
  return exported.reduce(function (acc, _ref) {
    var rawKey = _ref.rawKey,
        codeItem = _ref.codeItem;
    var reactEl = codeItemToReactElement(rawKey, codeItem);

    if (codeItem.place === "endOfBody") {
      acc.bodyItems.push(reactEl);
    }

    if (codeItem.place === "endOfHead") {
      acc.headItems.push(reactEl);
    }

    return acc;
  }, {
    bodyItems: [],
    headItems: []
  });
}

function insertItemsToDom(items) {
  var places = {};

  var _iterator = _createForOfIteratorHelper(items),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _step.value,
          el = _step$value.el,
          codeItem = _step$value.codeItem,
          rawKey = _step$value.rawKey;

      if (document.querySelector("[data-rawkey=\"".concat(rawKey, "\"]"))) {
        continue;
      }

      if (!Array.isArray(places[codeItem.place])) {
        places[codeItem.place] = [];
      }

      places[codeItem.place].push(el);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  Object.entries(places).forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        place = _ref3[0],
        elements = _ref3[1];

    var _selectorPosition$pla = _slicedToArray(selectorPosition[place], 2),
        selector = _selectorPosition$pla[0],
        position = _selectorPosition$pla[1];

    var el = document.querySelector(selector); // добавление скриптов может вызывать ошибку,
    // если в самом скрипте есть синтаксическая ошибка

    try {
      if (position === 'afterbegin') {
        el.prepend.apply(el, _toConsumableArray(elements));
      } else if (position === 'beforeend') {
        el.append.apply(el, _toConsumableArray(elements));
      } else {
        el.append.apply(el, _toConsumableArray(elements));
      }
    } catch (error) {}
  });
}

function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

function useRawChildrenSSR(children) {
  if (canUseDOM()) {
    return;
  }

  var childrenArray = React.Children.toArray(children);

  var _iterator2 = _createForOfIteratorHelper(childrenArray),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var reactEl = _step2.value;

      if (!isAllowedReactElement(reactEl)) {
        console.error('Element is not allowed in RawHtml', reactEl);
        continue;
      }

      var _reactElementToCodeIt = reactElementToCodeItem(reactEl),
          _reactElementToCodeIt2 = _slicedToArray(_reactElementToCodeIt, 2),
          rawKey = _reactElementToCodeIt2[0],
          codeItem = _reactElementToCodeIt2[1];

      CODE_ITEMS.push({
        rawKey: rawKey,
        codeItem: codeItem
      });
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}

function useRawChildren(children) {
  React.useEffect(function () {
    if (!canUseDOM()) {
      return;
    }

    var childrenArray = React.Children.toArray(children);
    var codeItems = [];

    var _iterator3 = _createForOfIteratorHelper(childrenArray),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var reactEl = _step3.value;

        if (!isAllowedReactElement(reactEl)) {
          console.warn('RawHtml: element is not allowed in RawHtml', reactEl);
          continue;
        }

        var _reactElementToCodeIt3 = reactElementToCodeItem(reactEl),
            _reactElementToCodeIt4 = _slicedToArray(_reactElementToCodeIt3, 2),
            rawKey = _reactElementToCodeIt4[0],
            codeItem = _reactElementToCodeIt4[1];

        var el = codeItemToDomElement(rawKey, codeItem);
        codeItems.push({
          rawKey: rawKey,
          codeItem: codeItem,
          el: el
        });
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    insertItemsToDom(codeItems);
    return function () {
      var _iterator4 = _createForOfIteratorHelper(codeItems),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var rawKey = _step4.value.rawKey;
          var el = document.querySelector("[data-rawkey=\"".concat(rawKey, "\"]"));

          if (el) {
            el.remove();
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    };
  }, [children]);
}

export default function RawHtml(_ref4) {
  var children = _ref4.children;
  useRawChildrenSSR(children);
  useRawChildren(children);
  return null;
}
RawHtml.getComponents = getComponents;
RawHtml.codeItemsToRawHtmlBody = codeItemsToRawHtmlBody;